import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from './Button';
import classNames from 'classnames';
import '../../../assests/css/popup.scss';

export interface popupProps {
    show: boolean,
    onClose: ()=> void,
    title?: string,
    size?: 'sm' | 'lg' | 'xl',
    children?: React.ReactNode,
    primaryCtaText?: string,
    disablePrimaryCta?: boolean,
    primaryCtaLoading?: boolean,
    primaryCtaOnClick?: ()=> void,
    secondaryCtaText?: string,
    secondaryCtaOnClick?: ()=> void,
    backdrop?: 'static' | undefined,
    customClassName?: string,
}

export default function Popup(props: popupProps) {

    const {title, show, size, children, primaryCtaText,
        customClassName,primaryCtaOnClick, onClose,
        secondaryCtaText, secondaryCtaOnClick,
        disablePrimaryCta, primaryCtaLoading} = props;

    return (
        <Modal show={show} backdrop={props.backdrop}
            onHide={()=> onClose()} size={size} centered={true} className={classNames('markex-popup-container', customClassName ? customClassName : '')}>
            {title? <Modal.Header closeButton className="popup-no-border">
                    <Modal.Title>{title}</Modal.Title>
            </Modal.Header>: null}
            <Modal.Body>
                {children}
            </Modal.Body>
            <Modal.Footer className="popup-no-border">
                {secondaryCtaText && secondaryCtaOnClick?
                    <Button type={'secondary'} buttonText={secondaryCtaText} onClick={secondaryCtaOnClick}/>
                        : null}
                {primaryCtaText && primaryCtaOnClick? 
                    <Button type={'primary'} buttonText={primaryCtaText} onClick={primaryCtaOnClick}
                    disable={disablePrimaryCta}
                    loading={primaryCtaLoading}
                    />
                        : null}
            </Modal.Footer>
        </Modal>
    );

}